import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import MainPageSkeleton from "../../../components/loaders/MainPageSkeleton";
import Container from '@mui/material/Container';
import {useParams} from "react-router";
import {scrollTop} from "../../../../config/values";
import Title from "../../../components/elements/Title";
import SwiperSlider from "../../../components/elements/slider/SwiperSlider";
import BannerSliderItem from "../components/BannerItem";
import {connect, setStore} from "trim-redux";
import EditorPreviewHTML from "../../../components/editor/EditorPreviewHTML";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";

function ShowPage({classes,setting}){
    const { t } = useTranslation();
    let { slug } = useParams();

    const [page, setPage] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const navigation = useNavigate();
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        setFetching(true);
        axios.get(`${defaultVariables.url}/front/page/${slug}`,config)
            .then(response => {
                setPage(response.data);
                setLoading(false);
                setFetching(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
                setFetching(false);
                setStore({error:404})
            });
    }

    useEffect(() => {
        if (!fetching) {
            scrollTop();
            loadData();
        }
    },[]);

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={ !!loading ? t('loading') : page.data?.name}>
            <div className="page-color-layout">
                {
                    !!loading ?
                        <Container maxWidth="xl" >
                            <MainPageSkeleton/>
                        </Container>
                        :
                        <>
                            <section className="category-page-top">
                                <Container maxWidth="xl" >
                                    <Grid container spacing={2}>
                                        <Grid item size={12}>
                                            <div className="infos">
                                                <div className="informations">
                                                    <Title component="h1" align="left" color="text" className="page-title">{page.data?.name}</Title>

                                                </div>
                                                <BreadCrumbs
                                                    front
                                                    singleLevel
                                                    firstText={page.data?.name}
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Container>
                            </section>

                            <Container maxWidth="lg">
                                <Grid container spacing={2}>
                                    {
                                        page.banners?.length > 0 &&
                                        <Grid item size={12} className="mb-30">
                                            <SwiperSlider
                                                data={page.banners}
                                                spaceBetween={20}
                                                slidesPerView={1}
                                                showNavigation={true}
                                                showPagination={false}
                                                //disablePaginationOnMobile={true}
                                                //disableNavigationOnMobile={true}
                                                autoplay={false}
                                                autoplaySpeed={3000}
                                                loop={false}
                                                renderSlide={(banner) => <BannerSliderItem banner={banner} />}
                                            />
                                        </Grid>
                                    }

                                    <Grid item size={12}>
                                        <EditorPreviewHTML html={page.data?.html} />
                                    </Grid>
                                </Grid>
                            </Container>
                        </>

                }
            </div>
        </AppAnimate>
    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(ShowPage));
